import { get, post, fetchget } from "../request.js";

export const ApiGetDictionary = {
  get: () => {
    return get(`/mydict/getword/*`);
  },
};

export const ApiGetDictWordVoice = {
  get: (word) => {
    return fetchget(`/utility/generate/wordsound/${word}`);
  },
};

export const ApiDeleteDictWord = {
  get: (word) => {
    return get(`/mydict/deleteword/${word}`);
  },
};

export const ApiSearchDictWord = {
  get: (word) => {
    return get(`/mydict/getword/${word}`);
  },
};

export const ApiSaveDictWord = {
  post: (wordObj) => {
    return post(`/mydict/saveword/`, wordObj);
  },
};

export const Apiv2DeleteDictWord = {
  get: (word) => {
    return get(`/mydictv2/deleteword/${word}`);
  },
};

export const Apiv2SearchDictWord = {
  get: (word) => {
    return get(`/mydictv2/getword/${word}`);
  },
};

export const Apiv2SaveDictWord = {
  get: (wordObj) => {
    return get(`/mydictv2/saveword/${wordObj}`);
  },
};
//
